import styled from 'styled-components';
import pageBg from '../assets/pageBg.png';

export const IndexPageStyle = styled.div`
  position: relative;
  overflow: hidden;
  margin: 0px;
  padding: 10px 0 0 0;
  background: url(${pageBg}) center center no-repeat;
  background-size: cover;
  height: 100vh; // 设置高度为 100vh
  display: flex; // 使用 flexbox 布局
  flex-direction: column; // 垂直排列子元素
`;
export const IndexPageContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  //.center-page {
  //  flex: 1;
  //},
    .left-page {
      flex: 1; /* 左侧面板占1份 */
      display: flex;
      flex-direction: column;
    }

    .center-page {
      flex: 2; /* 中间面板占2份 */
    }

    .right-page {
      flex: 1; /* 右侧面板占1份 */
    }
`;
